// Why a referred student never enrolled (waitlist / declined outcomes).
// Kept in sync with REFERRAL_OUTCOME_REASONS in backend/routes/referrals.py.
export const REFERRAL_OUTCOME_REASONS = [
  "Accepted",
  "Family rejected",
  "Student decline",
  "Family did not follow through",
  "Other",
  "Unable to contact family",
  "Found other placement",
  "District rejected",
  "District withdrew referral",
  "On hold by district",
  "Unable to serve",
  "Out of state",
];
